export default {
  // 面包屑
  projectList: '项目列表',
  deviceList: '设备列表',
  firmwareManagement: '固件管理',

  // 按钮
  uploadButton: '点击上传',
  cancelButton: '取消',
  confirmButton: '确定',
  importFirmwareFile: '导入固件文件',

  // 表单标签
  availableLabel: '是否可用',
  deviceNameLabel: '设备名称',
  releaseNoteLabel: '发布说明',
  fileLabel: '文件',
  deviceNamePlaceholder: '可以多选',
  releaseNotePlaceholder: '请输入固件发布说明',
  versionPlaceholder: '请输入版本号',

  // 表格列标题
  modelColumn: '模型',
  fileNameColumn: '文件名',
  firmwareVersionColumn: '固件版本号',
  fileSizeColumn: '文件大小',
  creatorColumn: '创建者',
  releaseDateColumn: '发布日期',
  releaseNoteColumn: '发布说明',
  statusColumn: '状态',

  // 验证消息
  releaseNoteRequired: '请输入发布说明.',
  deviceNameRequired: '请选择此固件所属的型号.',
  fileRequired: '请至少选择一个文件.',
  formatError: '格式错误.请选择zip文件.',

  // 上传消息
  uploading: '上传中',
  uploadCompleted: '已上传',
  uploadFailed: '上传失败',
  uploadingDescription: '正在上传中...',
  uploadCompletedDescription: '文件上传完成',
  uploadFailedDescription: '检查并重试.',

  // 筛选选项
  all: '全部',
}
